// @flow
import * as React from 'react'
import { withRouter } from 'next/router'
import { convertCharacterCategoryToListPropsAsync } from '../../models/Character'
import type { CharactersListPropsType } from '../../models/Character'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import { CharacterList } from '@components/Character/CharacterList'
function Characters (props: CharactersListPropsType): React.Node {
  return (
    <DiscoverLayout title={'Explore Top Characters on Dipsea'}>
      <CharacterList {...props}/>
    </DiscoverLayout>
  )
}
export default withRouter(Characters)

export async function getStaticProps (): Promise<{ props: CharactersListPropsType }> {
  const props = await convertCharacterCategoryToListPropsAsync()
  return { props }
}
